import TForm from './form.vue'
import TFormItem from './form-item.vue'

TForm.install = Vue => {
  Vue.component(TForm.name, TForm)
}

TFormItem.install = Vue => {
  Vue.component(TFormItem.name, TFormItem)
}

export {
  TForm,
  TFormItem
}



// WEBPACK FOOTER //
// ./src/module/form/index.js